import apiService from "./apiService";

const requestGetRemoteConfig = () => {
  return apiService.get(URIS.remoteConfig)
}

const requestUpdateRemoteConfig = (configPayload) => {
  return apiService.put(URIS.remoteConfig, configPayload)
}

export {requestGetRemoteConfig, requestUpdateRemoteConfig}

const URIS_D = (url, param1) => {
  return {}[url]
}

const URIS = {
  remoteConfig: '/v1/remote-configs',
}
